export const hydrateCopyObjectWithEntity = (copyData, entity) => {
  // console.log("hydrateCopyObjectWithEntity:", copyData, entity);
  if (!entity) return copyData;

  let hydratedCopyData;

  if (typeof copyData === "object") {
    hydratedCopyData = {};

    Object.entries(copyData).forEach(entry => {
      const [key, value] = entry;
      hydratedCopyData[key] = hydrateCopyObjectWithEntity(value, entity);
    });
  }

  if (typeof copyData === "string") {
    // entity name
    hydratedCopyData = copyData.replace(/\*name/g, entity.name);

    // subject name
    if (entity.subject) {
      hydratedCopyData = hydratedCopyData.replace(
        /\*username/g,
        `${entity.subject.firstName} ${entity.subject.lastName}`
      );
    }
  }

  return hydratedCopyData;
};

export const hydrateCopyObjectWithValue = (copyData, value) => {
  // console.log("hydrateCopyObjectWithValue:", copyData, value);
  if (!value || typeof copyData !== "string") return copyData;

  if (copyData.includes("{number}")) {
    return copyData.replaceAll(/\{number\}/g, value);
  }

  return `${copyData}${value}`;
};

// using the following export pattern so we can mock more easily using jest

const copyUtils = {
  hydrateCopyObjectWithEntity,
  hydrateCopyObjectWithValue
};

export default copyUtils;
